import { getSystemTheme } from './helpers.js'

const keyTheme = 'theme_preference' // 'light'  | 'dark' | 'system'
const keyLang = 'theme_language' // 'on' | 'off'
const keyAnalytics = 'theme_analytics' // 'on' | 'off'
const faviconPaths = {}

let systemThemeQuery = null

export function initTheme() {
	const storedTheme = getStoredTheme()
	const themeToApply = storedTheme || 'system'
	setTheme(themeToApply)
	setFavicon(getSystemTheme())
	observeSystemThemeChanges()
}

export function getTheme(fallback = 'system') {
	return localStorage.getItem(keyTheme) || fallback
}

export function getStoredTheme() {
	return localStorage.getItem(keyTheme)
}

export function setTheme(theme) {
	localStorage.setItem(keyTheme, theme)
	const appliedTheme = theme === 'system' ? getSystemTheme() : theme
	document.documentElement.dataset.theme = appliedTheme
}

export function getLang(fallback = 'en') {
	return localStorage.getItem(keyLang) || fallback
}
export function setLang(lang) {
	localStorage.setItem(keyLang, lang)
}

export function getAnalytics(fallback = 'off') {
	return localStorage.getItem(keyAnalytics) || fallback
}

export function setAnalytics(enabled) {
	localStorage.setItem(keyAnalytics, enabled ? 'on' : 'off')
}

export function isAnalyticsEnabled() {
	return localStorage.getItem(keyAnalytics) !== 'off'
}

function getFaviconElements() {
	const selectors = [
		'link[rel="icon"]',
		'link[rel="shortcut icon"]',
		'link[rel="apple-touch-icon"]',
		'link[rel*="icon"]',
	]
	const elements = selectors
		.flatMap((selector) => Array.from(document.querySelectorAll(selector)))
		.filter(Boolean)
	return Array.from(new Set(elements))
}

function getFaviconPath(theme) {
	const path = faviconPaths[theme] || ''
	return path
}

function buildFaviconUrl(theme) {
	const path = getFaviconPath(theme)
	if (!path) return ''
	const cacheKey = `${theme} - ${Date.now()}`
	const url = `${path}?v=${encodeURIComponent(cacheKey)}`
	return url
}

function setFavicon(theme) {
	const faviconUrl = buildFaviconUrl(theme)
	if (!faviconUrl) return false
	const faviconElements = getFaviconElements()
	if (!faviconElements.length) {
		return false
	}
	faviconElements.forEach((element) => {
		element.setAttribute('href', faviconUrl)
	})
	const tileMeta = document.querySelector(
		'meta[name="msapplication-TileImage"]'
	)
	if (tileMeta) {
		tileMeta.setAttribute('content', faviconUrl)
	}
	return true
}

export function observeSystemThemeChanges() {
	const supportsMatchMedia = typeof window.matchMedia === 'function'
	if (!supportsMatchMedia) {
		return false
	}
	if (systemThemeQuery) {
		return true
	}

	systemThemeQuery = window.matchMedia('(prefers-color-scheme: dark)')
	const handleChange = () => {
		setFavicon(getSystemTheme())
	}

	if (systemThemeQuery.addEventListener) {
		systemThemeQuery.addEventListener('change', handleChange)
	} else if (systemThemeQuery.addListener) {
		systemThemeQuery.addListener(handleChange)
	}

	return true
}
